import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {FirmaDTO} from '../../openapi/export-openapi';


export const firmaEntitiesAdapter: EntityAdapter<FirmaDTO> = createEntityAdapter<FirmaDTO>();
